import { House } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const HomeIcon = DeckardIconWrapper({ Icon: House });
